







import { Vue, Component, Prop } from 'vue-property-decorator';
import ProfielEditButton from '../../components/button/ProfielEditButton.vue';
import FindTeacherButton from '../../components/button/FindTeacherButton.vue';
import { Session } from '../../utils/Session';
import HeaderBase from '../../components/organisms/HeaderBase.vue';
import { getBuildingName } from '../../../src_server/entity/master/buildingData';

@Component({
  components: { ProfielEditButton, FindTeacherButton, HeaderBase },
})
export default class StudentHeaderNavigation extends Vue {
  showMenu() {
    console.log('showMenu');
  }
  get building() {
    return getBuildingName(Session.getSessionBuildingId());
  }

  private get logoLink() {
    return `/admin-menu-page?building=${Session.getSessionBuildingId()}`;
  }
  created() {
    document.title = `${getBuildingName(Session.getSessionBuildingId())}`;
  }
}
